import axios from 'axios'
import { authHeader } from '@/util/helpers'
import getEnv from '@/util/env'

const host = getEnv('VUE_APP_API_HOST')

const state = {
  settings: {},
  settings_array: [],
  regions: [],
  f5_nics: [],
  sql_servers: [],
  sql_load_balancers: [],
  customer_urls: [],
  permission_levels: []
}

const mutations = {
  'GET_SETTINGS' (state) {
    axios
      .get(
        `${host}/v2/settings`,
        {
          headers: authHeader(),
        },
      )
      .then(response => {
        state.settings_array = response.data
        var newObj = Object.assign({}, ...(response.data.map(item => ({ [item.name]: item.value }) )))
        state.settings = newObj
      })
  },
  'GET_REGIONS' (state) {
    axios
      .get(
        `${host}/v2/regions`,
        {
          headers: authHeader(),
        },
      )
      .then(response => {
        state.regions = response.data
      })
  },
  'GET_F5_NICS' (state) {
    axios
      .get(
        `${host}/v2/f5_nic`,
        {
          headers: authHeader(),
        },
      )
      .then(response => {
        state.f5_nics = response.data
      })
  },
  'GET_SQL_SERVERS' (state) {
    axios
      .get(
        `${host}/v2/servers/sql`,
        {
          headers: authHeader(),
        },
      )
      .then(response => {
        state.sql_servers = response.data
      })
  },
  'GET_SQL_LOAD_BALANCERS' (state) {
    axios
      .get(
        `${host}/v2/sql_load_balancers`,
        {
          headers: authHeader(),
        },
      )
      .then(response => {
        state.sql_load_balancers = response.data
      })
  },
  'GET_CUSTOMER_URLS' (state) {
    axios
      .get(
        `${host}/v2/customer_urls`,
        {
          headers: authHeader(),
        },
      )
      .then(response => {
        state.customer_urls = response.data
      })
  },
  'GET_PERMISSION_LEVELS' (state) {
    axios
      .get(
        `${host}/v2/permissions`,
        {
          headers: authHeader(),
        },
      )
      .then(response => {
        state.permission_levels = response.data
      })
  },
}

const getters = {
  settings: state => {
    return state.settings
  },
  settings_array: state => {
    return state.settings_array
  },
  regions: state => {
    return state.regions
  },
  f5_nics: state => {
    return state.f5_nics
  },
  sql_servers: state => {
    return state.sql_servers
  },
  sql_load_balancers: state => {
    return state.sql_load_balancers
  },
  customer_urls: state => {
    return state.customer_urls
  },
  permission_levels: state => {
    return state.permission_levels
  }
}

const actions = {
  load ({ commit }) {
    commit('GET_SETTINGS')
    commit('GET_REGIONS')
    commit('GET_SQL_SERVERS')
    commit('GET_SQL_LOAD_BALANCERS')
    commit('GET_CUSTOMER_URLS')
    commit('GET_PERMISSION_LEVELS')
  },
  load_regions ({ commit }) {
    commit('GET_REGIONS')
  },
  load_f5_nics ({ commit }) {
    commit('GET_F5_NICS')
  },
  load_sql_servers ({ commit }) {
    commit('GET_SQL_SERVERS')
  },
  load_sql_load_balancers ({ commit }) {
    commit('GET_SQL_LOAD_BALANCERS')
  },
  load_customer_urls ({ commit }) {
    commit('GET_CUSTOMER_URLS')
  },
  load_permission_levels ({ commit }) {
    commit('GET_PERMISSION_LEVELS')
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
